import { useEffect, useState } from 'react';

export default function useCostCalculator(
  cartoonSize,
  costingheads,
  totalCBMperpc,
  updatingCalc,
  fieldData,
  setFieldData,
  reload,
  reload2,
  changeCount,
  costingTableData,
  showTables,
  state
) {

  useEffect(() => {
    let tempOutcost = 0; // Start with the initial outcost value
    let tempIncost = 0; // Start with the initial incost value
    if (
      cartoonSize.length == 1 &&
      cartoonSize[0].Carton_Length == 0 &&
      cartoonSize[0].Carton_Width == 0 &&
      cartoonSize[0].Carton_Thick == 0
    ) {
    } else {
      // cartoonSize.forEach(element => {
      //   const { Carton_Length, Carton_Width, Carton_Thick, Carton_Unit, Carton_PCS, CartonType } =
      //     element;

      //   if (Carton_Length == 0 && Carton_Width == 0 && Carton_Thick == 0) {
      //     return;
      //   }

      //   if (Carton_PCS !== 0) {
      //     let unitvalue = 1;
      //     if (Carton_Unit === 'inch') {
      //       unitvalue = 2400;
      //     } else if (Carton_Unit === 'cm') {
      //       unitvalue = 15483.84;
      //     }

      //     const cartonVolume =
      //       (((Carton_Length + Carton_Width) * 2 + 2) * (Carton_Width + Carton_Thick + 0.5)) /
      //       unitvalue;

      //     if (CartonType === 'master') {
      //       tempOutcost += (cartonVolume * costingheads.MasterCarton) / Carton_PCS;
      //     } else {
      //       tempIncost += (cartonVolume * costingheads.Innercarton) / Carton_PCS;
      //     }
      //   }
      // });
      setFieldData(prev => ({
        ...prev,
        innercost: tempIncost.toFixed(2) || 0,
        mastercost: tempOutcost.toFixed(2) || 0
      }));
    }
  }, [cartoonSize, cartoonSize[0]]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setFieldData(prev => ({
        ...prev,
        shippingcost: Number(costingheads.FOB * totalCBMperpc) || 0,
      }));
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [costingheads.FOB, totalCBMperpc]);

  useEffect(() => {

    let firstTableTotal = 0;
    let secondTableTotal = 0;
    let thirdTableTotal = 0;
    let fourthTableTotal = 0;
    let fifthTableTotal = 0;
    let sixTotal = 0;
    let profilePercentage = 0;
    let profileAmount = 0;
    let USD = 0;
    let Gstcost = 0;
    let testingcost = 0;
    let othercost = 0;
    let laisoncost = 0;
    let overheadcost = 0;
    let misccost = 0;
    let innercost = 0;
    let mastercost = 0;
    let shippingcost = 0;
    let polishcost = 0;
    let itemcost = 0;
    let gstcost = 0;
    let laisoncost2 = 0;
    let testingcost2 = 0;
    let othercost2 = 0;
    let overheadcost2 = 0;
    let misccost2 = 0;
    const calculateTotal = (tableData, key) => {
      if (tableData.some(item => item[key] != '')) {
        return tableData.reduce((total, item) => {
          return total + (parseFloat(item[key]) || 0);
        }, 0);
      }
      return 0;
    };

    if (!showTables.material) {
      firstTableTotal = Number(fieldData.Netwgt) * Number(fieldData.perkgrate);
    } else {
      firstTableTotal = calculateTotal(costingTableData.CostingMaterial, 'totalmaterialcost');
    }
    if (!showTables.process) {
      // thirdTableTotal = fieldData.finishcost;
      thirdTableTotal = Number(fieldData.size) * Number(fieldData.rate);
    } else {
      thirdTableTotal = calculateTotal(costingTableData.CostingProcess, 'prcsamt');
    }
  if (!showTables.accessories && (fieldData.createdAt || updatingCalc.Accessories)) {
      // console.log('if');
      // console.log('fieldData',fieldData);
      fourthTableTotal = fieldData.accessorycost / 1;
    } else {
      // console.log('else');
      fourthTableTotal = calculateTotal(costingTableData.CostingAccessory, 'matcost');
    }

    if (!showTables.packing && (fieldData.createdAt || updatingCalc.Packing || updatingCalc.Fitting)) {
      fifthTableTotal = fieldData.packingcost / 1;
    } else {
      fifthTableTotal = calculateTotal(costingTableData.Costingpacking, 'packingtotalcost');
    }
    secondTableTotal = calculateTotal(costingTableData.CostingWood, 'woodamount');
    if (fieldData.fittingcost) {
      sixTotal = +fieldData.fittingcost;
    }
    if (fieldData.gstcost) {
      Gstcost = +fieldData.gstcost;
    }
    if (fieldData.testingcost) {
      testingcost = +fieldData.testingcost;
    }
    if (fieldData.othercost) {
      othercost = +fieldData.othercost;
    }
    if (fieldData.laisoncost) {
      laisoncost = +fieldData.laisoncost;
    }
    if (fieldData.overheadcost) {
      overheadcost = +fieldData.overheadcost;
    }
    if (fieldData.misccost) {
      misccost = +fieldData.misccost;
    }
    if (fieldData.innercost) {
      innercost = +fieldData.innercost;
    }
    if (fieldData.mastercost) {
      mastercost = +fieldData.mastercost;
    }
    if (fieldData.shippingcost) {
      // console.log('fieldData.shippingcost', fieldData.shippingcost);
      shippingcost = +fieldData.shippingcost;
    }
    if (fieldData.polishcost) {
      polishcost = +fieldData.polishcost;
    }
    if (fieldData.Netwgt && fieldData.perkgrate) {
      itemcost = firstTableTotal
    } else {
      itemcost = firstTableTotal + secondTableTotal;
    }
    const finishcost = thirdTableTotal;
    const accessorycost = fourthTableTotal;
    const fittingcost = fifthTableTotal;
    const totalCost =
      firstTableTotal +
      secondTableTotal +
      thirdTableTotal +
      fourthTableTotal +
      // fifthTableTotal +
      // + innercost
      // + mastercost
      + polishcost;
    // +shippingcost;
    // console.log('fifthTableTotal', fifthTableTotal);
    // console.log("totalCost")
    // console.log(totalCost)
    // console.log("fifthTableTotal")
    // console.log(fifthTableTotal)
    // console.log("shippingcost")
    // console.log(shippingcost)
    // console.log("fieldData.profitcost")
    // console.log(fieldData.profitcost)
    // console.log("sixTotal")
    // console.log(sixTotal)

    const totalCost2 = totalCost + fifthTableTotal + shippingcost + (fieldData.profitcost ?? 0) / 1 + sixTotal;
    const totalCost3 = totalCost2 + overheadcost;
    const totalCost4 = totalCost3 + misccost;

    if (fieldData.targetCost && totalCost4) {
      profileAmount = +fieldData.targetCost - +totalCost4;
      profilePercentage = (+profileAmount * 100) / +totalCost4;
    }

    if (fieldData.currencyRate && fieldData.subtotalwohcost) {
      USD = +fieldData.subtotalwohcost / +fieldData.currencyRate;
    }
    if (fieldData.gstper) {
      const result = (+totalCost.toFixed(2) * +fieldData.gstper) / 100;
      gstcost = +result.toFixed(2);
    }
    if (fieldData.laisonper) {
      const result = (+totalCost.toFixed(2) * +fieldData.laisonper) / 100;
      laisoncost2 = +result.toFixed(2);
    }
    if (fieldData.testingper) {
      const result = (+totalCost.toFixed(2) * +fieldData.testingper) / 100;
      testingcost2 = +result.toFixed(2);
    }
    if (fieldData.otherper) {
      const result = (+totalCost.toFixed(2) * +fieldData.otherper) / 100;
      othercost2 = +result.toFixed(2);
    }

    if (fieldData.overheadper) {
      // console.log('totalCost2', totalCost2);
      const result = (+totalCost2.toFixed(2) * +fieldData.overheadper) / 100;
      overheadcost2 = +result.toFixed(2);
    }
    if (fieldData.miscper) {
      const result = (+totalCost3.toFixed(2) * +fieldData.miscper) / 100;
      misccost2 = +result.toFixed(2);
    }
    setFieldData(prev => ({
      ...prev,
      itemcost: +itemcost.toFixed(2),
      finishcost: +finishcost.toFixed(2),
      // ...(updatingCalc.Accessories ? {} : { accessorycost: +accessorycost.toFixed(2) }),
      // ...(updatingCalc.Packing ? {} : { packingcost: +fittingcost.toFixed(2) }),
      ...(updatingCalc.Accessories || fieldData.accessorycost ? {} : { accessorycost: +accessorycost.toFixed(2) }),
      ...(updatingCalc.Packing || fieldData.packingcost ? {} : { packingcost: +fittingcost.toFixed(2) }),
      ...(updatingCalc.ProcessCost || fieldData.processcost ? {} : { processcost: +finishcost.toFixed(2) }),

      // packingcost: +fittingcost.toFixed(2),
      totalinr: +totalCost4.toFixed(2),
      targetcostUSD: +USD.toFixed(2),
      overallcost: +totalCost.toFixed(2),
      subtotalcost: +totalCost2.toFixed(2),
      subtotalwohcost: +totalCost3.toFixed(2),
      shippingcost: shippingcost,
      gstcost: updatingCalc.GST ? fieldData.gstcost : gstcost,
      laisoncost: updatingCalc.Laison ? fieldData.laisoncost : laisoncost2,
      testingcost: updatingCalc.Testing ? fieldData.testingcost : testingcost2,
      othercost: updatingCalc.Other ? fieldData.othercost : othercost2,
      overheadcost: updatingCalc.OverHeadCost ? fieldData.overheadcost : overheadcost2,
      misccost: updatingCalc.Misc ? fieldData.misccost : misccost2
    }));
  }, [
    reload,
    changeCount,
    // state.costingId,
    fieldData.overallcost,
    fieldData.subtotalcost,
    fieldData.subtotalwohcost,
    fieldData.innercost,
    fieldData.mastercost,
    fieldData.shippingcost
  ]);

  useEffect(() => {
    let firstTotal = 0;
    let secondTotal = 0;
    let profilePercentage = 0;
    let profileAmount = 0;
    let USD = 0;
    let Gstcost = 0;
    let testingcost = 0;
    let othercost = 0;
    let laisoncost = 0;
    let overheadcost = 0;
    let misccost = 0;
    let innercost = 0;
    let mastercost = 0;
    let shippingcost = 0;
    let polishcost = 0;
    let wiringcost = 0;
    let gstcost = 0;
    let laisoncost2 = 0;
    let testingcost2 = 0;
    let othercost2 = 0;
    let overheadcost2 = 0;
    let misccost2 = 0;
    let processcost = 0;


    if (fieldData.itemcost || fieldData.finishcost) {
      firstTotal = +fieldData.itemcost + +fieldData.finishcost;
    }
    if (fieldData.accessorycost) {
      secondTotal = +fieldData.accessorycost
    }
    if (fieldData.gstcost) {
      Gstcost = +fieldData.gstcost;
    }
    if (fieldData.testingcost) {
      testingcost = +fieldData.testingcost;
    }
    if (fieldData.othercost) {
      othercost = +fieldData.othercost;
    }
    if (fieldData.laisoncost) {
      laisoncost = +fieldData.laisoncost;
    }
    if (fieldData.overheadcost) {
      overheadcost = +fieldData.overheadcost;
    }
    if (fieldData.misccost) {
      misccost = +fieldData.misccost;
    }
    if (fieldData.innercost) {
      innercost = +fieldData.innercost;
    }
    if (fieldData.mastercost) {
      mastercost = +fieldData.mastercost;
    }
    if (fieldData.shippingcost) {
      shippingcost = +fieldData.shippingcost;
    }
    if (fieldData.polishcost) {
      polishcost = +fieldData.polishcost;
    }
    if (fieldData.wiringcost) {
      wiringcost = +fieldData.wiringcost;
    }
    if (fieldData.processcost) {
      processcost = +fieldData.processcost;
    }

    const total =
      firstTotal +
      secondTotal +
      // innercost +
      // mastercost +
      polishcost

    // const total2 = total + Gstcost + testingcost + othercost + laisoncost + wiringcost + shippingcost + (fieldData.profitcost / 1) + (fieldData.packingcost / 1) + (fieldData.fittingcost / 1);
    const total2 = total + wiringcost + processcost + shippingcost + (fieldData.profitcost / 1) + (fieldData.packingcost / 1) + (fieldData.fittingcost / 1);
    const total3 = total2 + overheadcost;
    const total4 = total3 + misccost;

    if (total) {
      const total = fieldData?.overallcost;
      const profit = (+total * +fieldData?.profitper / 1) / 100;
      const targetCost = profit + +total;
      profileAmount = (targetCost - total) / 1;
    }
    if (fieldData.currencyRate && fieldData.subtotalwohcost) {
      USD = +fieldData.subtotalwohcost / +fieldData.currencyRate;
    }
    if (fieldData.gstper) {
      const result = (+total.toFixed(2) * +fieldData.gstper) / 100;
      gstcost = +result.toFixed(2);
    }
    if (fieldData.laisonper) {
      const result = (+total.toFixed(2) * +fieldData.laisonper) / 100;
      laisoncost2 = +result.toFixed(2);
    }
    if (fieldData.testingper) {
      const result = (+total.toFixed(2) * +fieldData.testingper) / 100;
      testingcost2 = +result.toFixed(2);
    }
    if (fieldData.otherper) {
      const result = (+total.toFixed(2) * +fieldData.otherper) / 100;
      othercost2 = +result.toFixed(2);
    }
    if (fieldData.overheadper) {
      const result = (+total2.toFixed(2) * +fieldData.overheadper) / 100;
      overheadcost2 = +result.toFixed(2);
    }
    if (fieldData.miscper) {
      const result = (+total3.toFixed(2) * +fieldData.miscper) / 100;
      misccost2 = +result.toFixed(2);
    }
    setFieldData(prev => ({
      ...prev,
      totalinr: +total4.toFixed(2),
      // profitper: +profilePercentage.toFixed(2),
      // profitcost: +profileAmount.toFixed(2),
      ...(updatingCalc.Profitcost ? {} : { profitcost: +profileAmount.toFixed(2) }),
      targetcostUSD: +USD.toFixed(2),
      overallcost: +total.toFixed(2),
      subtotalcost: +total2.toFixed(2),
      subtotalwohcost: +total3.toFixed(2),
      gstcost: updatingCalc.GST ? fieldData.gstcost : gstcost,
      laisoncost: updatingCalc.Laison ? fieldData.laisoncost : laisoncost2,
      testingcost: updatingCalc.Testing ? fieldData.testingcost : testingcost2,
      othercost: updatingCalc.Other ? fieldData.othercost : othercost2,
      overheadcost: updatingCalc.OverHeadCost ? fieldData.overheadcost : overheadcost2,
      misccost: updatingCalc.Misc ? fieldData.misccost : misccost2
    }));
  }, [
    reload2,
    state.reload2,
    fieldData.overallcost,
    fieldData.subtotalcost,
    fieldData.subtotalwohcost,
    fieldData.innercost,
    fieldData.mastercost,
    fieldData.shippingcost,
  ]);
  useEffect(() => {
    if (state.Currencyrate.id && state?.Currencyrate?.exchangerate) {
      setFieldData(prev => ({
        ...prev,
        currencyRate: prev.currencyRate ?? state?.Currencyrate?.exchangerate
      }));
    }
  }, [state.Currencyrate]);
  return null;
}
